import { render, staticRenderFns } from "./AddWhereHouse.vue?vue&type=template&id=1bff7d19&"
import script from "./AddWhereHouse.vue?vue&type=script&lang=js&"
export * from "./AddWhereHouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports